import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, FormFeedback, FormGroup, Input, Label } from 'reactstrap'
import { ProductContext } from '../../../../store'
import { PostData } from '../../../../services/FetchData'
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton'
import AsyncSelect from "react-select/async";
import debounce from 'lodash.debounce'
import { toast } from 'react-toastify'

const AddFilter = () => {
	const [pageLoader, setPageLoder]	= useState(true),
		[selectedFilters, setSelectedFilters] = useState([]),
		[errors, setErrors]	= useState({}),
		[title, setTitle]	= useState(""),
		{currentWebsiteId}	= useContext(ProductContext),
		navigate	= useNavigate()
	
	useEffect(() => {
		if( currentWebsiteId ){
			setPageLoder(false)
		}
	}, [currentWebsiteId])

	useEffect(() => {
		let errorsLocal	= {...errors}
		if( title ){
			delete errorsLocal["title"]
		}
		if( selectedFilters.length > 0 ){
			delete errorsLocal["filters"]
		}
		setErrors(errorsLocal)
	}, [title, selectedFilters])

	const debouncedFilterQuery = useCallback(
		debounce((inputValue, callback) => {
			getFilterQuery(inputValue).then(callback);
		}, 500),
		[]
	);

	const getFilterQuery	= async (inputValue) => {
		let response	= await PostData("ms1", "api/v1/filters/getAllFilters", { websiteId: currentWebsiteId, searchKey: inputValue, page: 1, limit: 1000 });
		if (response !== "Invalid") {
			if (response.status === "success") {
				let filtersResponse	= response.data.filters,
					filtersLocal	= filtersResponse.filter((filter) => filter.attribute !== "effective_price" && filter.attribute !== "reviews" ).map((filter) => ({label: filter.title, value: filter.filterId}))
				return filtersLocal
			}
		}
	}

	const createFilter = () => {
		let errorsLocal	= {}
		if (!title.trim()) {
			errorsLocal["title"]	= "Filter title is required"
		}
		if (selectedFilters.length === 0) {
			errorsLocal["filters"]	= "Parent filter is required"
		}
		console.log(selectedFilters);
		setErrors(errorsLocal)
		if( Object.keys(errorsLocal).length === 0 ){
			let filters
			PostData("ms1", "api/v1/filters/createFilter", {websiteId: currentWebsiteId, title, filters: selectedFilters}).then((response) => {
				if( response !== "Invalid" && response !== "undefined" ){
					if( response.status === "success" ){
						toast.success(response.message)
						return navigate("/search/filter")
					}
				}
				setErrors({api: "Try again later"})
			})
		}
	}

	const handleCancel = () => {
		return navigate("/search/filter");
	}

	return (
		<div className="addFilterContainer">
			<button className="addFilterBackButton" onClick={() => handleCancel()}>
				<i className="fa-solid fa-arrow-left"></i>
				Back
			</button>
			<div className="addFilterHeader">
				<h2 className="addFilterTitle">Add filter</h2>
			</div>
			{pageLoader ?
				<DetailSkeleton />
			:
				<>
					<div className="addFilterForm">
						{errors.api &&
							<Alert color="danger">
								{errors.api}
							</Alert>
						}
						<div className="addFilterField">
							<FormGroup>
								<Label className="addFilterLabel">Filter title</Label>
								<Input
									type="text"
									placeholder="Filter title"
									value={title}
									onChange={(e) => setTitle(e.target.value)}
									className="addFilterInput"
									invalid={errors.title? true : false}
								/>
								{errors.title &&
									<FormFeedback>{errors.title}</FormFeedback>
								}
							</FormGroup>
						</div>
						<div className="addFilterField">
							<FormGroup>
								<label className="addFilterLabel">Parent filters</label>
								<div className="addFilterParentFiltersContainer">
									<AsyncSelect
										isMulti
										isClearable
										cacheOptions
										key={"searchParentFilter"}
										value={selectedFilters}
										onChange={setSelectedFilters}
										defaultOptions // show some options initially
										loadOptions={debouncedFilterQuery}
										placeholder="Parent Filters..."
										className={errors.filters? "is-invalid" : ""}
									/>
									{errors.filters &&
										<FormFeedback>{errors.filters}</FormFeedback>
									}
								</div>
							</FormGroup>
						</div>
					</div>
					<div className="addFilterActions">
						<button className="addFilterCancelButton" onClick={() => handleCancel()}>
							Cancel
						</button>
						<button className="addFilterContinueButton" onClick={() => createFilter()}>
							Continue
						</button>
					</div>
				</>
			}
		</div>
	)
}

export default AddFilter